import { normalizeEmailBodyFormat } from "../../../types/emailBodyFormat";
import type { NotificationChannel } from "../../../components/NotificationChannelToggle/NotificationChannelToggle";

/** Canonical JSON for comparing reminder configs — ignores object identity / key order drift. */

function channelAlwaysEmail(_t?: NotificationChannel): NotificationChannel {
  return "email";
}

export function stableSignatureVisitReminder(config: {
  enabled: boolean;
  type: "sms" | "email";
  details?: {
    emailTitle?: string;
    text?: string;
    daysInAdvance?: number;
    emailBodyFormat?: string | null;
  };
}): string {
  const d = config.details ?? {};
  const fmt =
    config.type === "sms" ? null : normalizeEmailBodyFormat(d.emailBodyFormat);
  return JSON.stringify({
    enabled: Boolean(config.enabled),
    type: config.type,
    emailTitle: d.emailTitle ?? "",
    text: d.text ?? "",
    daysInAdvance: d.daysInAdvance ?? 2,
    emailBodyFormat: config.type === "sms" ? null : fmt,
  });
}

export function stableSignatureBrandIntro(config: {
  enabled: boolean;
  type?: NotificationChannel;
  emailTitle?: string;
  text?: string;
  daysBeforeVisit?: number;
  emailBodyFormat?: string | null;
}): string {
  return JSON.stringify({
    enabled: Boolean(config.enabled),
    type: channelAlwaysEmail(config.type),
    emailTitle: config.emailTitle ?? "",
    text: config.text ?? "",
    daysBeforeVisit: config.daysBeforeVisit ?? 3,
    emailBodyFormat: normalizeEmailBodyFormat(config.emailBodyFormat),
  });
}

export function stableSignaturePostVisit(config: {
  enabled: boolean;
  type?: NotificationChannel;
  emailTitle?: string;
  text?: string;
  daysAfterVisit?: number;
  emailBodyFormat?: string | null;
}): string {
  return JSON.stringify({
    enabled: Boolean(config.enabled),
    type: channelAlwaysEmail(config.type),
    emailTitle: config.emailTitle ?? "",
    text: config.text ?? "",
    daysAfterVisit: config.daysAfterVisit ?? 2,
    emailBodyFormat: normalizeEmailBodyFormat(config.emailBodyFormat),
  });
}

export function stableSignatureBookingConfirmation(config: {
  enabled: boolean;
  type?: NotificationChannel;
  emailTitle?: string;
  text?: string;
  emailBodyFormat?: string | null;
}): string {
  return JSON.stringify({
    enabled: Boolean(config.enabled),
    type: channelAlwaysEmail(config.type),
    emailTitle: config.emailTitle ?? "",
    text: config.text ?? "",
    emailBodyFormat: normalizeEmailBodyFormat(config.emailBodyFormat),
  });
}

export function stableSignatureWeddingRate(config: {
  enabled?: boolean;
  type?: NotificationChannel;
  emailTitle?: string;
  text?: string;
  emailBodyFormat?: string | null;
}): string {
  return JSON.stringify({
    enabled: Boolean(config.enabled),
    type: channelAlwaysEmail(config.type),
    emailTitle: config.emailTitle ?? "",
    text: config.text ?? "",
    emailBodyFormat: normalizeEmailBodyFormat(config.emailBodyFormat),
  });
}
